import { createFileRoute } from '@tanstack/react-router'
import { Main } from '@/components/layout/main'
import { PageToolbar } from '@/components/layout/page-header'
import { InstanceSubnav } from '@/features/instances/components/instance-subnav'
import { DiagnosticResultsList } from '@/features/diagnostics/components/diagnostic-results-list'

type DiagnosticsSearch = {
  status?: 'pending' | 'completed' | 'partial' | 'failed'
  scope?: 'all' | 'manual' | 'alert'
  q?: string
  sort?: 'created_desc' | 'created_asc' | 'failed_desc' | 'success_desc'
}

export const Route = createFileRoute(
  '/_authenticated/instances/$instanceId/diagnostics/'
)({
  validateSearch: (search: Record<string, unknown>): DiagnosticsSearch => {
    const status = search.status
    const scope = search.scope
    const q = search.q
    const sort = search.sort

    return {
      status:
        status === 'pending' ||
        status === 'completed' ||
        status === 'partial' ||
        status === 'failed'
          ? status
          : undefined,
      scope:
        scope === 'all' || scope === 'manual' || scope === 'alert'
          ? scope
          : undefined,
      q: typeof q === 'string' ? q : undefined,
      sort:
        sort === 'created_desc' ||
        sort === 'created_asc' ||
        sort === 'failed_desc' ||
        sort === 'success_desc'
          ? sort
          : undefined,
    }
  },
  component: DiagnosticsListPage,
})

function DiagnosticsListPage() {
  const { instanceId } = Route.useParams()
  const numericId = parseInt(instanceId, 10)

  return (
    <>
      <PageToolbar />

      <Main className='flex flex-1 flex-col gap-4 sm:gap-6'>
        <InstanceSubnav instanceId={instanceId} activeTab='diagnostics' />
        <DiagnosticResultsList instanceId={numericId} />
      </Main>
    </>
  )
}
